<template>
  <div v-if="loading">
    <div class="row">
      <div class="col-12">
        <label class="font28 font500">
          <mdb-icon icon="cogs" /> จัดการผู้ใช้งาน</label>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-12">
        <!-- <div class="d-flex flex-row mr-5"> -->
        <div class="row">
          <div class="align-self-center ml-3">ค้นหา User</div>
          <div class="col-12 col-md-4 p-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon">
                  <mdb-icon far icon="edit" />
                </span>
              </div>
              <!-- <input
                type="text"
                class="form-control"
                v-model="searchTxt"
                aria-describedby="basic-addon"
                width="80%"
              /> -->
              <input id="filterInput" type="search" class="form-control" v-model="searchQuery" placeholder="" />
            </div>
          </div>
          <div class="col-12 col-md-6 py-1">
            <!-- <button
              type="button"
              class="btn btn-search color_white font12"
              style="font-weight:400; margin-left:-8px"
              @click="Search()"
            >
              <i class="fab fa-sistrix"></i> Search
            </button> -->
            <!-- <router-link to="Setuseradd">
							<button id="Setuseradd" type="button" class="btn btn-add color_white font12" style="font-weight:400;"><i class="fas fa-plus"></i> Add</button>
						</router-link> -->
            <!-- <button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i class="fas fa-times"></i> Cancel</button> -->
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- <mdb-datatable
        :arrows="true"
        :data="filteredPhotoFeed"
        striped
        bordered
        :searching="false"
        scrollY
        maxHeight="450px"
      /> -->
      <div>
        <mdb-tbl striped bordered :searching="false" scrollY maxHeight="450px" :arrows="true">
          <mdb-tbl-head>
            <tr class="table-header table-sm">
              <th>{{ data.columns[0].label }}</th>
              <th></th>
              <th>ชื่อผู้ใช้</th>
              <th>ประเภทสมาชิก</th>
              <th>ใช้งานล่าสุด</th>
              <th>สถานะ</th>
            </tr>
          </mdb-tbl-head>

          <mdb-tbl-body>
            <tr v-for="(item, index) in filteredPhotoFeed.rows" :key="index">
              <td>{{ index + 1 }}</td>
              <td class="text-center">
                <a @click="funshowModal(item.id)" class="text-center btnbtn" style="max-width:110px;" :dataid="item.id">
                  <label class="bg-file-search text-white font14" style="cursor: pointer;">
                    <!-- <mdb-icon far icon="file-alt"/> -->
                    <i class="fas fa-file-alt fa-13"></i></label>
                </a>
              </td>
              <td>{{ item.full_name }}</td>
              <td>{{ item.type_member }}</td>
              <td>
                {{ item.last_login ? item.last_login : "-" }}
              </td>
              <td>
                <div class="rows text-center font500" v-if="item.status_user === 1">
                  <label class="switch my-0"><input type="checkbox" checked disabled /><span class="slider round"
                      style="cursor:auto;"></span></label>
                </div>
                <div v-else class="rows text-center font500">
                  <label class="switch my-0"><input type="checkbox" disabled /><span class="slider round"
                      style="cursor:auto;"></span></label>
                </div>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </div>
    </div>

    <mdb-container>
      <!-- <mdb-btn color="primary" @click.native="showModal = true">Launch modal</mdb-btn> -->
      <mdb-modal :show="showModal" @close="showModal = false" scrollable centered>
        <mdb-modal-header>
          <mdb-modal-title>
            <mdb-icon icon="fingerprint" />แก้ไขข้อมูล</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <div class="row justify-content-center">
            <div class="col-10 col-md-9">
              <div class="row justify-content-center mt-3">
                <div class="col-5 align-self-center">User</div>
                <div class="col-7 pl-0">
                  <input type="text" id="full_name" v-model="full_name" class="form-control form-control-sm"
                    width="100%" disabled />
                </div>
              </div>
              <div class="row justify-content-center mt-3">
                <div class="col-5 align-self-center">รหัสผ่าน</div>
                <div class="col-7 pl-0">
                  <input type="text" id="full_name" v-model="password" class="form-control form-control-sm" width="100%"
                    disabled />
                </div>
              </div>
              <div class="row justify-content-center mt-3">
                <div class="col-5 align-self-center">วันที่สมัคร</div>
                <div class="col-7 pl-0">{{ date_regis }}</div>
              </div>
              <div class="row justify-content-center">
                <div class="col-5 align-self-center">สถานะ</div>
                <div class="col-3 pl-0">
                  <!-- <div class="custom-control custom-switch">
										<input type="checkbox" class="custom-control-input" id="status_user" v-model="status_user" />
										<label class="custom-control-label" for="status_user">ปิด-เปิด</label>
									</div> -->
                  <label class="switch" style="">
                    <input type="checkbox" v-model="status_user" />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-4 align-self-center pl-0">ปิด - เปิด</div>
              </div>
              <div class="row justify-content-center">
                <div class="col-5 align-self-center">ประเภทสมาชิก</div>
                <div class="col-7 pl-0">

                  <div class="d-flex">
                    <div class="form-check pl-0">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="one" value="member"
                        v-model="type_member">
                      <label class="mb-0" for="one">member</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="exampleRadios" id="two" value="VIP"
                        v-model="type_member">
                      <label class="mb-0" for="two">VIP</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 text-center my-4">
                  <button type="button" class="btn btn-search color_white mr-3 font12" style="font-weight:400;"
                    @click="edituser()">
                    บันทึก
                  </button>
                  <button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"
                    @click="editusercancle()">
                    ยกเลิก
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mdb-modal-body>
      </mdb-modal>
    </mdb-container>
  </div>
</template>

<script>
  // import {mdbDatatable} from 'mdbvue'
  import moment from "moment";
  import {
    mapGetters,
    mapActions
  } from "vuex";
  export default {
    name: "Manageuser",
    components: {
      // mdbDatatable,
    },
    data() {
      return {
        loading: false,
        showModal: false,
        searchTxt: "",
        full_name: "",
        date_regis: "",
        status_user: "",
        type_member: "",
        idedituser: 0,
        searchQuery: null,
        password: null,
        data: {
          columns: [{
              label: "#",
              field: "id2",
              sort: true,
            },
            {
              label: "",
              field: "id",
              sort: true,
              format: (value) => {
                return (
                  '<div class="text-center btnbtn" style="max-width:110px;" dataid="' +
                  value +
                  '"><label class="bg-file-search text-white font14" style="cursor: pointer;" ><mdb-icon far icon="file-alt" /><i class="fas fa-file-alt fa-13"></i></label></div>'
                );
              },
            },
            {
              label: "ชื่อผู้ใช้",
              field: "full_name",
              sort: true,
              format: (value) => {
                return (
                  '<div class="rows" style="min-width:160px;">' + value + "</div>"
                );
              },
            },
            {
              label: "วันที่สมัคร",
              field: "date_regis",
              sort: true,
              format: (value) => {
                return (
                  '<div class="rows" style="min-width:160px;">' +
                  moment(value).format("DD/MM/YYYY HH:mm:ss") +
                  "</div>"
                );
              },
            },
            {
              label: "ใช้งานล่าสุด",
              field: "last_login",
              sort: true,
              format: (value) => {
                return (
                  '<div class="rows" style="min-width:160px;">' +
                  moment(value).format("DD/MM/YYYY HH:mm:ss") +
                  "</div>"
                );
              },
            },
            {
              label: "สถานะ",
              field: "status_user",
              sort: true,
              format: (value) => {
                if (value == 1) {
                  return '<div class="rows text-center font500"><label class="switch my-0"><input type="checkbox" checked disabled/><span class="slider round" style="cursor:auto;"></span></label></div>';
                } else {
                  return '<div class="rows text-center font500"><label class="switch my-0"><input type="checkbox" disabled/><span class="slider round" style="cursor:auto;"></span></label></div>';
                }
              },
            },
          ],
          rows: null,
        },
      };
    },
    computed: {
      ...mapGetters({
        isLogin: "isLogin",
        user: "user",
        token: "token",
      }),
      // eslint-disable-next-line vue/return-in-computed-property
      filteredPhotoFeed() {
        if (this.data) {
          const searchQuery = this.searchQuery;
          if (!searchQuery) {
            return this.data;
          }
          let columstable = this.data.columns;
          // eslint-disable-next-line vue/return-in-computed-property
          // eslint-disable-next-line no-unused-vars
          const searchString = searchQuery.trim().toLowerCase();
          // eslint-disable-next-line array-callback-return
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          const rownsdata = this.data.rows.filter((item) => {
            if (item.username.toLowerCase().indexOf(searchString) !== -1) {
              return item;
            }
          });
          let sumdata;
          sumdata = {
            columns: columstable,
            rows: rownsdata
          };
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          return sumdata;
        }
      },
    },
    methods: {
      ...mapActions({
        storeLogin: "login",
        storeLoout: "logout",
        loadsession: "loadsession",
        callApiMotherFucker: "callApiMotherFucker",
      }),
      editusercancle() {
        this.showModal = false;
      },
      funshowModal(data) {
        let detailuser = this;
        detailuser.idedituser = data; // เอาid มาเก็บไว้ในตัวแปร idedituser เพื่อจะนำไปอัพเดท
        if (data > 0) {
          // this.loading = true
          detailuser
            .callApiMotherFucker({
              method: "post",
              path: "/list_member/member",
              data: {
                id: detailuser.idedituser
              },
            })
            .then((res) => {
              detailuser.full_name = res.payload[0].username;
              detailuser.password = res.payload[0].password;
                detailuser.type_member = res.payload[0].type_member;
              detailuser.status_user = res.payload[0].status_user;
              detailuser.date_regis = res.payload[0].date_regis;
              detailuser.showModal = true;
            });
        }
      },
      edituser() {
        if (this.full_name == "" || this.full_name == null) {
          return this.$swal({
            html: '<i class="fa fa-user-circle fa-6x"></i><br><br>กรุณากรอกชื่อผู้ใช้<br>',
            timer: 5000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
        this.callApiMotherFucker({
          method: "post",
          path: "/update_member",
          data: {
            id: this.idedituser,
            full_name: this.full_name,
            type_member: this.type_member,
            status: this.status_user == true ? 1 : 0,
          }, // this.status_user ถ้าเป็น 1 คือ true , ถ้าเป็น 0 คือ false
        }).then((res) => {
          console.log("payload", res.payload);
          if (res.code == 0) {
            this.$swal({
              icon: "success",
              html: res.msg,
              timer: 8000,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if (result) {
                location.reload();
              }
            });
          } else {
            this.$swal({
              icon: "error",
              html: res.msg,
              timer: 8000,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        });
      },
      async Search() {
        this.loading = false;
        if (this.searchTxt == "") {
          await this.callApiMotherFucker({
            method: "post",
            path: "/list_member/query",
            data: {},
          }).then((res) => {
            if (res.payload) {
              this.data.rows = this.$add_index(res.payload);
              this.loading = true;
            }
          });
        } else {
          await this.callApiMotherFucker({
            method: "post",
            path: "/list_member/query",
            data: {},
          }).then((res) => {
            if (res.payload) {
              this.data.rows = this.$add_index(res.payload);
            }
          });
          this.data.rows = this.data.rows.filter((val) => {
            if (val.username.search(this.searchTxt) >= 0) {
              return true;
            } else {
              return false;
            }
          });
          this.loading = true;
        }
      },
    },
    async mounted() {
      await this.callApiMotherFucker({
        method: "post",
        path: "/list_member/All",
        data: {},
      }).then((res) => {
        this.loading = true;
        if (res.payload) {
          this.data.rows = this.$add_index(res.payload);
        }
      });

      // let detailuser = this;
      // $(".btnbtn").on("click", function() {
      //   let id = $(this).attr("dataid") || 0;
      //   detailuser.idedituser = id; // เอาid มาเก็บไว้ในตัวแปร idedituser เพื่อจะนำไปอัพเดท
      //   if (id > 0) {
      //     // this.loading = true
      //     detailuser
      //       .callApiMotherFucker({
      //         method: "post",
      //         path: "/list_member/member",
      //         data: { id: detailuser.idedituser },
      //       })
      //       .then((res) => {
      //         detailuser.full_name = res.payload[0].full_name;
      //         detailuser.status_user = res.payload[0].status_user;
      //         detailuser.date_regis = res.payload[0].date_regis;
      //         detailuser.showModal = true;
      //       });
      //   }
      // });
    },
  };
</script>
<style scoped>
  .fa-13 {
    font-size: 1em;
  }

  .field-icon {
    margin-left: 25px;
    margin-right: 10px;
    margin-top: 0px;
    position: relative;
    z-index: 2;
  }

  .label1 {
    color: red !important;
  }

  .modal-dialog .modal-content .modal-header {
    border-top-left-radius: 0.1rem !important;
    border-top-right-radius: 0.1rem !important;
    background-color: #f5904b !important;
    color: #ffffff;
  }
  
.form-check-input[type="radio"]:checked+label:after{
background-color: #f5904b;
}
.form-check-input[type="radio"]:checked+label:after{
border: 2px solid #f5904b;
}
</style>